import { Component, Input, OnChanges } from '@angular/core';
/* import { ExpenseAttachment } from 'src/app/models/expense-attachment.model';
 */import { ExpenseAttachmentsService } from '../../services/expense_attachments.service';
import { ReportPaymentService } from '../../../expense-reports/services/report_payment.service';

@Component({
  selector: 'app-attachment-viewer',
  templateUrl: './attachment-viewer.component.html',
  styleUrls: ['./attachment-viewer.component.scss']
})
export class AttachmentViewerComponent {
  error: any
  attachmentId?: any
  attachment?: any;
  loading = false;

  constructor(
    private attachmentService: ExpenseAttachmentsService,
    private ReportPaymentService: ReportPaymentService
  ) { }

  ngOnInit() {
    this.attachmentService.currentAttachmentId$.subscribe((attachmentId) => {
      if (attachmentId) {
        this.attachmentId = attachmentId
        this.loadAttachment();
      }
    })

    this.ReportPaymentService.currentPaymentAttachmentId$.subscribe((attachmentId) => {
      if (attachmentId) {
        this.attachmentId = attachmentId
        this.loadPaymentAttachment();
      }
    })
  }

  loadAttachment(): void {
    this.loading = true;
    this.error = '';
    this.attachmentService.getById(this.attachmentId).subscribe({
      next: (data) => {
        this.attachment = data;
        this.loading = false;
      },
      error: (err) => {
        console.log(err)
        this.error = 'No se pudo cargar el archivo.';
        this.loading = false;
      }
    });
  }

  loadPaymentAttachment(): void {
    this.loading = true;
    this.error = '';
    this.ReportPaymentService.getAttachmentById(this.attachmentId).subscribe({
      next: (data) => {
        this.attachment = data;
        this.loading = false;
      },
      error: (err) => {
        console.log(err)
        this.error = 'No se pudo cargar el archivo.';
        this.loading = false;
      }
    });
  }

  get isPDF(): boolean {
    return this.attachment?.fileType?.includes('pdf') ?? false;
  }

  get isImage(): boolean {
    return this.attachment?.fileType?.startsWith('image/') ?? false;
  }

  get fileUrl(): string {
    return this.attachment?.signedUrl ?? '';
  }

  viewAttachment(id: string): void {
    this.attachmentId = id;
  }

  openInNewTab(): void {
    if (this.fileUrl) {
      window.open(this.fileUrl, '_blank')?.focus();
    }
  }
}